import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { closeMenu } from "../store/generalSlice";

function MenuButton(props: { route: string , label: string, onClicked?: () => void}) {
    const dispatch = useDispatch();

    const { route, label, onClicked } = props;

    const onLinkClicked = () => {
        dispatch(closeMenu());
        onClicked?.();
    }

    return <Link to={route} onClick={onLinkClicked}>
        <div className="menu-button">{label}</div>
    </Link>
}


export default MenuButton;